import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import ChevronLeftIcon from '@atlaskit/icon/utility/chevron-left';
import ChevronRightIcon from '@atlaskit/icon/utility/chevron-right';
import { Flex, Text, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type YearSelectorProps = {
	onPreviousYear: () => void;
	onNextYear: () => void;
	year: number;
};

export const YearSelector = ({ onNextYear, onPreviousYear, year }: YearSelectorProps) => {
	const { formatMessage } = useIntl();
	return (
		<Flex justifyContent="space-between" alignItems="center" xcss={yearPickerContainerStyles}>
			<IconButton
				label={formatMessage(messages.previousYear)}
				appearance="subtle"
				spacing="default"
				onClick={onPreviousYear}
				icon={ChevronLeftIcon}
			/>
			<Text weight="bold">{year}</Text>
			<IconButton
				label={formatMessage(messages.nextYear)}
				appearance="subtle"
				spacing="default"
				onClick={onNextYear}
				icon={ChevronRightIcon}
			/>
		</Flex>
	);
};

const yearPickerContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	paddingLeft: 'space.100',
	paddingRight: 'space.100',
	marginBottom: 'space.200',
});
